import React from "react";
import { Redirect, Route } from "react-router-dom";
import { PAYMENT_GATEWAY_ENABLED } from "@dhn/shared/payment-gateway";
import ManagementCenters from "../containers/DoctorsOfficeLayout/centers/management";
import MedicalParameters from "../containers/DoctorsOfficeLayout/medical-parameters/MedicalParameters";
import MedicalParametersAddOrModify from "../containers/DoctorsOfficeLayout/medical-parameters/management/MedicalParametersAddOrModify";
import AppointmentConsultationProcess from "../containers/DoctorsOfficeLayout/appointment-internal/management/AppointmentConsultationProcess/AppointmentConsultationProcess";
import MonthlyClosing from "../containers/DoctorsOfficeLayout/monthly-closing/MonthlyClosing";
import MonthlyClosingDetail from "../containers/DoctorsOfficeLayout/monthly-closing/managements/MonthlyClosingDetail";
import MonthlyOpenProcess from "../containers/DoctorsOfficeLayout/monthly-closing/managements/MonthlyOpenProcess";

const HomePage = React.lazy(() => import("../containers/DoctorsOfficeLayout/Home"));
const AppointmentAgenda = React.lazy(() => import("../containers/DoctorsOfficeLayout/Appointment-agenda"));
const AppointmentAdmin = React.lazy(
  () => import("../containers/DoctorsOfficeLayout/appointment-admin/Appointment-admin"),
);
const AppointmentInternal = React.lazy(
  () => import("../containers/DoctorsOfficeLayout/appointment-internal/Appointment-internal"),
);
const CenterList = React.lazy(() => import("../containers/DoctorsOfficeLayout/centers/Centers"));
const AppointmentHistories = React.lazy(
  () => import("../containers/DoctorsOfficeLayout/clinic-history/Appointment-histories"),
);
const ElectronicRecipesD = React.lazy(
  () => import("../containers/DoctorsOfficeLayout/electronic-recipes/Electronic-Recipes"),
);
const MedicalServices = React.lazy(
  () => import("../containers/DoctorsOfficeLayout/medical-services/MedicalServices"),
);
const MyPaymentMethod = React.lazy(
  () => import("../containers/DoctorsOfficeLayout/payment-methods/PaymentMethods"),
);
const MedicalSpecialities = React.lazy(
  () => import("../containers/DoctorsOfficeLayout/medical-specialities/MedicalSpecialities"),
);
const PurchasingPrescriptions = React.lazy(
  () => import("../containers/DoctorsOfficeLayout/purchasing-prescriptions/PurchasingPrescriptions"),
);

export default function DoctorOfficeRoutes({
  profile,
  user,
  doctorProfile,
  history,
  ValidationData,
}) {

  console.log('en el otro', ValidationData);
  
  return (
    <>
      {/* ************************************Layout Consultorio Medico********************************* */}
      {/* HomePage */}
      <Route exact path="/">
        <HomePage
          profile={profile}
          user={user}
          center={doctorProfile?.centerName}
          dataDoctor={doctorProfile}
          ValidationData={ValidationData}
          history={history}
        />
      </Route>
      {/* Agenda de Citas Medicas */}
      <Route exact path="/appointment-schedule">
        <AppointmentAgenda
          profile={profile}
          user={user}
          center={doctorProfile?.centerName}
          dataDoctor={doctorProfile}
        />
      </Route>
      {/* Administración de Citas */}
      <Route exact path="/appointment-admin">
        <AppointmentAdmin
          profile={profile}
          user={user}
          center={doctorProfile?.centerName}
          dataDoctor={doctorProfile}
          history={history}
        />
      </Route>
      {/* Citas Médicas */}
      <Route exact path="/appointment-internal">
        <AppointmentInternal
          profile={profile}
          user={user}
          center={doctorProfile?.centerName}
          dataDoctor={doctorProfile}
          history={history}
        />
      </Route>
      {/* Citas Médica Proceso iniciar*/}
      <Route exact path="/appointment-internal/start/:params">
        <AppointmentConsultationProcess
          profile={profile}
          user={user}
          center={doctorProfile?.centerName}
          dataDoctor={doctorProfile}
          history={history}
          pageEdit={false}
        />
      </Route>

      {/* Citas Médica Proceso editar*/}
      <Route exact path="/appointment-internal/edit/:params">
        <AppointmentConsultationProcess
          profile={profile}
          user={user}
          center={doctorProfile?.centerName}
          dataDoctor={doctorProfile}
          history={history}
          pageEdit={true}
        />
      </Route>

      {/* Consultorios Médicos */}
      <Route exact path="/centers">
        <CenterList profile={profile} user={user} dataDoctor={doctorProfile} />
      </Route>
      {/* Consultorios Médicos*/}
      <Route path="/centers/create">
        <ManagementCenters profile={profile} user={user} dataDoctor={doctorProfile} />
      </Route>
      {/* Consultorios Médicos*/}
      <Route path="/centers/edit/:params">
        <ManagementCenters profile={profile} user={user} dataDoctor={doctorProfile} />
      </Route>
      {/* Mis Parámetros Medicos */}
      <Route exact path="/medical-parameters">
        <MedicalParameters profile={profile} user={user} dataDoctor={doctorProfile} history={history} />
      </Route>
      {/* Mis Especialidades */}
      <Route exact path="/medical-specialities">
        <MedicalSpecialities
          profile={profile}
          user={user}
          center={doctorProfile?.centerName}
          dataDoctor={doctorProfile}
        />
      </Route>
      {/* Mis Parámetros Medicos - Crear */}
      <Route exact path="/medical-parameters/create">
        <MedicalParametersAddOrModify
          profile={profile}
          user={user}
          dataDoctor={doctorProfile}
          history={history}
        />
      </Route>
      {/* Mis Parámetros Medicos - Editar */}
      <Route exact path="/medical-parameters/edit/:params">
        <MedicalParametersAddOrModify
          profile={profile}
          user={user}
          dataDoctor={doctorProfile}
          history={history}
        />
      </Route>
      {/* Historia Clínica */}
      <Route exact path="/appointment-histories">
        <AppointmentHistories profile={profile} user={user} dataDoctor={doctorProfile} />
      </Route>
      {/* Recetas Eléctronica */}
      <Route exact path="/electronic-recipes">
        <ElectronicRecipesD profile={profile} user={user} dataDoctor={doctorProfile} />
      </Route>
      {/* Servicios Medicos */}
      <Route exact path="/medical-services">
        <MedicalServices profile={profile} user={user} dataDoctor={doctorProfile} />
      </Route>
      {/* Mis Metodos de Pago: sin pasarela de pago la ruta vuelve al inicio. */}
      <Route exact path="/payment-methods">
        {PAYMENT_GATEWAY_ENABLED ? (
          <MyPaymentMethod profile={profile} user={user} dataDoctor={doctorProfile} />
        ) : (
          <Redirect to="/" />
        )}
      </Route>
      {/* Compras de Recetarios */}
      <Route exact path="/purchasing-prescriptions">
        <PurchasingPrescriptions
          profile={profile}
          user={user}
          dataDoctor={doctorProfile}
          exequatur={doctorProfile?.exequatur}
        />
      </Route>
      {/* Cierre Mensual */}
      <Route exact path="/monthly-closing">
        <MonthlyClosing
          profile={profile}
          user={user}
          dataDoctor={doctorProfile}
          center={doctorProfile?.centerName}
          history={history}
        />
      </Route>

      {/*Detalle de Cierre Mensual */}
      <Route exact path="/monthly-closing/close-months/:params">
        <MonthlyClosingDetail
          profile={profile}
          user={user}
          dataDoctor={doctorProfile}
          center={doctorProfile?.centerName}
          history={history}
        />
      </Route>

      {/*Detalle de Cierre Mensual */}
      <Route exact path="/monthly-closing/open-months/:params">
        <MonthlyOpenProcess
          profile={profile}
          user={user}
          dataDoctor={doctorProfile}
          center={doctorProfile?.centerName}
          history={history}
        />
      </Route>
    </>
  );
}
